var render = function render(){var _vm=this,_c=_vm._self._c;return _c('utility-list-component',{attrs:{"collectKey":_vm.collectKey,"utility-type":'utilityCollections'}})
}
var staticRenderFns = []

export { render, staticRenderFns }